/* eslint-disable */
import Vuetify from 'vuetify/lib/framework'
import '@mdi/font/css/materialdesignicons.css'
import '@fortawesome/fontawesome-free/css/all.css'
import '@/assets/css/styles.css'

export function useVuetify(app) {
    app.use(Vuetify)
}

export function createVuetify() {
    const vuetify = new Vuetify({
        theme: {
            customProperties: true,
            themes: {
                light: {
                    primary: '#1867C0',
                    secondary: '#5CBBF6',
                    tertiary: '#E57373',
                    accent: '#005CAF',
                },
            },
        },
        icons: {
            iconfont: "fa", // 'mdi' || 'mdiSvg' || 'md' || 'fa' || 'fa4' || 'faSvg'
        },
    })

    return vuetify;
}